// tslint:disable:max-line-length

import React from 'react';

export const ObjectPayment = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M6.5,5.8c0,0.6,0.4,0.9,1.1,1.1V4.7H7.5C6.8,4.8,6.5,5.3,6.5,5.8z" />
      <path d="M8.6,8.8v2.3C9.4,11,9.8,10.7,9.8,10C9.8,9.4,9.4,9.1,8.6,8.8z" />
      <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8.6,12.4v1H7.5v-0.9c-1.5-0.2-2.4-0.9-3-1.9l1.3-0.8 c0.5,0.7,1,1.2,1.8,1.4V8.6C6.1,8.2,4.7,7.7,4.7,6c0-1.5,1.1-2.5,2.8-2.6V2.5h1.2v0.9c1.3,0.2,2,0.8,2.5,1.6L9.9,5.9 C9.6,5.4,9.2,5,8.6,4.8v2.3c1.7,0.4,2.9,1,2.9,2.7C11.5,11.1,10.6,12.3,8.6,12.4z" />
    </svg>
  );
};
